"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchievementRuleStatus = void 0;
var AchievementRuleStatus;
(function (AchievementRuleStatus) {
    AchievementRuleStatus["ACTIVE"] = "ACTIVE";
    AchievementRuleStatus["INACTIVE"] = "INACTIVE";
})(AchievementRuleStatus || (exports.AchievementRuleStatus = AchievementRuleStatus = {}));
//# sourceMappingURL=rule.js.map